/* eslint-disable no-restricted-syntax */

export const INVOICE_ITEM_DIFF_CONSTANTS = {
  CHANGED: "changed",
  UNCHANGED: "unchanged",
  DELETED: "deleted",
  NEW: "new",
};
export const getInvoiceItemDiff = (
  currentItems = [],
  snapshotItems = [],
  options = {}
) => {
  const fieldsToCompare = options.fieldsToCompare || [
    "unitPrice",
    "paidOnPurchaseOrder",
    "name",
    "quantity",
  ];

  if (!Array.isArray(currentItems) || !Array.isArray(snapshotItems)) {
    throw new Error("Both currentItems and snapshotItems must be arrays");
  }

  const currentMap = new Map(
    currentItems.map((item) => {
      if (!item.id) throw new Error("All items must have an id field");
      return [item.id, item];
    })
  );

  const snapshotMap = new Map(
    snapshotItems.map((item) => {
      if (!item.id) throw new Error("All items must have an id field");
      return [item.id, item];
    })
  );

  const allIds = new Set([...currentMap.keys(), ...snapshotMap.keys()]);

  const result = [];

  for (const id of allIds) {
    const current = currentMap.get(id);
    const snapshot = snapshotMap.get(id);

    if (current && snapshot) {
      const changes = getFieldChanges(current, snapshot, fieldsToCompare);

      if (changes.hasChanges) {
        result.push({
          ...current,
          status: INVOICE_ITEM_DIFF_CONSTANTS.CHANGED,
          oldValues: changes.oldValues,
          changedFields: changes.changedFields,
        });
      } else {
        result.push({
          ...current,
          status: INVOICE_ITEM_DIFF_CONSTANTS.UNCHANGED,
        });
      }
    } else if (!current && snapshot) {
      result.push({
        ...snapshot,
        status: INVOICE_ITEM_DIFF_CONSTANTS.DELETED,
      });
    } else if (current && !snapshot) {
      result.push({
        ...current,
        status: INVOICE_ITEM_DIFF_CONSTANTS.NEW,
      });
    }
  }

  return result;
};

const getFieldChanges = (current, snapshot, fieldsToCompare) => {
  const changedFields = [];
  const oldValues = {};

  for (const field of fieldsToCompare) {
    if (current[field] !== snapshot[field]) {
      changedFields.push(field);
      oldValues[field] = snapshot[field];
    }
  }

  return {
    hasChanges: changedFields.length > 0,
    changedFields,
    oldValues,
  };
};
